export default __webpack_public_path__ + "static/g204-fd186787f1a3bf1bdc3938c7d3d89b61.jpg";